<template>
  <img src="https://assets.payl8r.com/images/calculator-images/Calendar.png" alt="basket" style="height: 40px">
</template>